const DAWN_PLATE = {
  slug: "dawn-plate",
  name: "Dawn Plate",
  description: "Blessed by the light of dawn",
  rarity: "rare",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 22 },
    { stat: "goldColor", value: 15 },
    { stat: "goldRes", value: 8 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_yellow",
    frameIndex: 1
  },
  bodySprite: "characters/body/body_gold",
  tags: ["daily-rotation", "metal"]
};
export {
  DAWN_PLATE
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9kYXduLXBsYXRlLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQgeyBJdGVtRGVmaW5pdGlvbiB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IERBV05fUExBVEU6IEl0ZW1EZWZpbml0aW9uID0ge1xuICBzbHVnOiAnZGF3bi1wbGF0ZScsXG4gIG5hbWU6ICdEYXduIFBsYXRlJyxcbiAgZGVzY3JpcHRpb246ICdCbGVzc2VkIGJ5IHRoZSBsaWdodCBvZiBkYXduJyxcbiAgcmFyaXR5OiAncmFyZScsXG4gIHNsb3Q6ICdhcm1vcicsXG4gIHNob3BDYXRlZ29yeTogJ21ldGFsLWFybW9yJyxcbiAgc3RhdENoYW5nZXM6IFtcbiAgICB7IHN0YXQ6ICdhcm1vcicsIHZhbHVlOiAyMiB9LFxuICAgIHsgc3RhdDogJ2dvbGRDb2xvcicsIHZhbHVlOiAxNSB9LFxuICAgIHsgc3RhdDogJ2dvbGRSZXMnLCB2YWx1ZTogOCB9LFxuICBdLFxuICBzcHJpdGU6IHtcbiAgICBzaGVldDogJ3dhcmRyb2JlL21ldGFsL21ldGFsX3llbGxvdycsXG4gICAgZnJhbWVJbmRleDogMSxcbiAgfSxcbiAgYm9keVNwcml0ZTogJ2NoYXJhY3RlcnMvYm9keS9ib2R5X2dvbGQnLFxuICB0YWdzOiBbJ2RhaWx5LXJvdGF0aW9uJywgJ21ldGFsJ10sXG59O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBRU8sTUFBTSxhQUE2QjtBQUFBLEVBQ3hDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQWE7QUFBQSxFQUNiLFFBQVE7QUFBQSxFQUNSLE1BQU07QUFBQSxFQUNOLGNBQWM7QUFBQSxFQUNkLGFBQWE7QUFBQSxJQUNYLEVBQUUsTUFBTSxTQUFTLE9BQU8sR0FBRztBQUFBLElBQzNCLEVBQUUsTUFBTSxhQUFhLE9BQU8sR0FBRztBQUFBLElBQy9CLEVBQUUsTUFBTSxXQUFXLE9BQU8sRUFBRTtBQUFBLEVBQzlCO0FBQUEsRUFDQSxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsWUFBWTtBQUFBLEVBQ1osTUFBTSxDQUFDLGtCQUFrQixPQUFPO0FBQ2xDOyIsCiAgIm5hbWVzIjogW10KfQo=
